import Icon from '../components/Icon.vue'

Icon.register({
  forward: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500.5 231.4c15.3 12.8 15.3 36.4 0 49.2l-192 160c-20.6 17.2-52.5 2.8-52.5-24.6v-320c0-27.4 31.9-41.7 52.5-24.6zM244.5 231.4c15.3 12.8 15.3 36.4 0 49.2l-192 160c-20.6 17.2-52.5 2.8-52.5-24.6v-320c0-27.4 31.9-41.7 52.5-24.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/forward.js
// module id = 1369
// module chunks = 0